/**
 * An answer from a conversation recorded before full responses were kept.
 *
 * Only the answer's text survives for these turns, so this renders the text
 * and says plainly that the rest (figures, evidence, charts) was not kept —
 * rather than faking a full response that `ZoeTurnCard` would half-render.
 * Every answer given since conversations were recorded in full resumes
 * through `ZoeTurnCard`, exactly as it was first shown.
 */

import { Archive } from 'lucide-react';

interface Props {
  text: string;
}

export default function ZoeArchivedAnswer({ text }: Props) {
  return (
    <div className="rounded-xl border border-border bg-card/40 p-4 space-y-2">
      <p className="text-sm text-foreground leading-relaxed whitespace-pre-wrap">{text}</p>
      <p className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <Archive className="h-3.5 w-3.5" aria-hidden />
        Earlier answer — shown as text; its figures and evidence weren&apos;t kept.
      </p>
    </div>
  );
}
